import React from 'react';
import { ContactForm } from './ContactForm';
import { MainContentPanel } from '../components/MainContentPanel';
import KotobeeBookMapping from './ADFSConfig/KotobeeBookMapping';

export function Overview() {
  return (
    <>
      <ContactForm />
      <MainContentPanel>
        <KotobeeBookMapping />
      </MainContentPanel>
    </>
  );
}
